import withMatcher from '#/utils/withMatcher';
import { IPlaylistWithFavorite } from '../reducers/playlist';

export const createActionPlaylistSetPlaylist = withMatcher(
  (payload: IPlaylistWithFavorite) => {
    return {
      type: 'playlist/set_album',
      payload,
    };
  }
);

export const createActionPlaylistStartLoading = withMatcher(() => {
  return {
    type: 'playlist/start_loading',
  };
});

export const createActionPlaylistStopLoading = withMatcher(() => {
  return {
    type: 'playlist/stop_loading',
  };
});

export const createActionPlaylistSetError = withMatcher((error: boolean) => {
  return {
    type: 'playlist/set_error',
    payload: error,
  };
});

export const createActionPlaylistSetIsLiked = withMatcher(
  (payload: { liked: boolean }) => {
    return {
      type: 'playlist/set_playlist_is_liked',
      payload,
    };
  }
);

export const createActionPlaylistSetTrackFavorite = withMatcher(
  (payload: { track: string; favorite: boolean }) => {
    return {
      type: 'playlist/set_track_is_favorite',
      payload,
    };
  }
);

export const createActionPlaylistSetTracks = withMatcher(
  (payload: { tracks: IPlaylistWithFavorite['tracks']['items'] }) => {
    return {
      type: 'playlist/set_tracks',
      payload,
    };
  }
);

export const createActionPlaylistReset = withMatcher(() => {
  return {
    type: 'playlist/reset',
  };
});
